import { Notify } from 'quasar'

export default {
  methods: {
    showError (error) {
      let msg = 'Ismeretlen hiba!'

      // Exception
      // {
      //   err: {
      //     response: {
      //       data: {
      //         error: {
      //           code: 4232
      //           exception: [
      //             0: { message: uzenet }
      //           ]
      //         }
      //       }
      //     }
      //   }
      // }
      console.log(error)
      console.log(error.response)
      if (error.response && error.response.data && error.response.data.code && error.response.data.code == '401') {
        msg = 'Kód: 401'
        msg = msg + '\n' + 'Újra be kell jelentkeznie!'
        console.log(error.response)
        console.log(msg)
        window.location = '/login';
      } else {
        if (error.response && error.response.data && error.response.data.error && error.response.data.error.code) {
          msg = 'Kód: ' + error.response.data.error.code
        }
        if (error.response && error.response.data && error.response.data.error && error.response.data.error.exception && error.response.data.error.exception[0]) {
          msg = msg + '\n' + error.response.data.error.exception[0].message
        }

        // error = response
        // {
        //   error: {
        //     data: {
        //       success: false,
        //       message: 'uzenet'
        //     }
        //   }
        // }
        if (error.data && error.data.success === false && error.data.message && error.data.message !== '') {
          msg = error.data.message
        }

        // form error
        if (("response" in error) && ("data" in error.response) && ("code" in error.response.data)) {
          msg = 'Kód: ' + error.response.data.code
          if (error.response.data.code == 422) {
            msg += ' Hibás adatbeküldés!'
          }
        }
        if (("response" in error) && ("data" in error.response) && ("status" in error.response.data)) {
          msg = 'Kód: ' + error.response.data.status
          if (error.response.data.status == 422) {
            msg += ' Hibás adatbeküldés!'
          }
        }
        if (("response" in error) && ("data" in error.response) && ("message" in error.response.data)) {
          msg += 'Üzenet: ' + error.response.data.message
        }


        if (("response" in error) && ("data" in error.response) && ("code" in error.response) && ("message" in error.response.data)) {
          msg = 'Kód: ' + error.response.data.code + ' Üzenet: ' + error.response.data.message

        }

        // if (error.response && error.response.data && error.response.data.message) {
        //   let message = error.response.data.message
        //   if (message === 'Validation Failed') {
        //     message = 'Ellenőrzés nem sikerült'
        //   }
        //
        //   msg = msg + '\n' + 'Üzenet:' + message
        // }
      }

      Notify.create({
        message: 'Kommunikációs hiba!',
        type: 'negative',
        timeout: 1000,
        caption: msg,
        actions: [
          {
            label: 'Bezár'
          }
        ]
      })
    }
  }
}
